import React, { useState, useEffect } from 'react';
import { useEffectOnActive } from 'keepalive-for-react';
import Loader from './Loader';

const PageLoader = ({ loading, children, minLoadTime = 0 }) => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  // Сброс при активации страницы из кеша - не показываем лоадер
  useEffectOnActive((active) => {
    if (active) {
      setShowLoader(false);
      setIsInitialLoad(false);
    }
  }, []);

  useEffect(() => {
    if (isInitialLoad && !loading) {
      // Без задержки, мгновенно показываем контент
      setShowLoader(false);
      setIsInitialLoad(false);
    }

    // После первичной загрузки лоадер больше не поднимаем. Раньше здесь
    // стоял setShowLoader(loading): любой повторный loading:true подменял
    // весь контент полноэкранным лоадером, children размонтировались, а при
    // возврате монтировались заново — страница прыгала наверх. Догрузка
    // данных (пагинация, обновление) обязана показываться внутри страницы,
    // а не поверх неё
  }, [loading, isInitialLoad]);

  if (showLoader) {
    return <Loader fullscreen />;
  }

  return <>{children}</>;
};

export default PageLoader;
